import './src/styles/global.css';
import './src/localization/i18n';
import "driver.js/dist/driver.css";
import React, { useEffect } from 'react';
import { SnackbarProvider } from 'notistack';
import NotificationProvider from './src/components/root/notification';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { I18nextProvider, useTranslation } from 'react-i18next';
import { isWeb } from './src/utilities/platform';
import { StyledNotiStackContent, THEME_GREEN } from './src/constants/style';
import { green, blue, red, yellow, lightGreen, deepOrange, orange } from '@mui/material/colors';
import { CheckCircle, Error, Warning, Info, AutoAwesome, DoDisturbAlt, Lightbulb, LightbulbCircle, CircleNotifications, NotificationsActive } from '@mui/icons-material';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { PermissionProvider } from './src/components/root/permission-provider';
import { VersionProvider } from './src/components/root/version-provider';
import { UnsavedChangesProvider } from './src/components/root/unsaved-changes-provider';

const theme = createTheme({
  palette: {
    primary: {
      main: THEME_GREEN,
    },
  },
});

const LocalizationProvider = ({ children }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (isWeb && localStorage.LANG) i18n.changeLanguage(localStorage.LANG);
    else {
      i18n.changeLanguage('en-AU');
      localStorage.LANG = 'en-AU';
    }
  }, []);

  return (<I18nextProvider i18n={i18n}>{children}</I18nextProvider>);
};

export const wrapRootElement = ({ element, props }) => {
  return (
    <SnackbarProvider iconVariant={{
      success: <CheckCircle color={lightGreen[500]} sx={{ mr: 1 }} />,
      error: <Error color={red[500]} sx={{ mr: 1 }} />,
      warning: <NotificationsActive color={orange[500]} sx={{ mr: 1 }} />,
      info: <AutoAwesome color={blue[500]} sx={{ mr: 1 }} />,
    }} Components={{
      success: StyledNotiStackContent,
      error: StyledNotiStackContent,
      warning: StyledNotiStackContent,
      info: StyledNotiStackContent,
    }}>
      <VersionProvider>
        <PermissionProvider>
          <NotificationProvider>
            <ThemeProvider theme={theme}>
              <DndProvider backend={HTML5Backend}>
                <UnsavedChangesProvider>
                  <LocalizationProvider>{element}</LocalizationProvider>
                </UnsavedChangesProvider>
              </DndProvider>
            </ThemeProvider>
          </NotificationProvider>
        </PermissionProvider>
      </VersionProvider>
    </SnackbarProvider>
  );
};